import { Stack, styled } from '@mui/material';

export const DndListWrapper = styled(Stack)({
  height: '100%',
  overflow: 'auto',
});
